module.exports = __webpack_public_path__ + "static/media/map marker.94ebab95.svg";